import ButtonComp from '../components/buttons/button';
import { connect } from 'react-redux';
import { mapMistakesEnable } from './actions';

const mapStateToPropsRes = (state) => {
  return {
    enabled: state.mapMistakes.enabled,
    text: 'Ziņot par labojumiem!'
  };
};

const mapDispatchToPropsRes = (dispatch) => {

  return {
    onClick: (data, active) => {
        dispatch(mapMistakesEnable(active));
    }
  };
};

const MapMistakesCont = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(ButtonComp);

export default MapMistakesCont;



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapMistakes/containerToggle.js